module.exports = ".icon-label{display:flex;justify-content:center;align-items:center}.icon-label img{margin-left:.5rem}.unit{font-size:.7em}"